module.exports = __webpack_public_path__ + "fonts/fake-receipt.f844e03.ttf";